const state = {
    configurations: null,
    configurationsLoaded:false
};

const getters = {
    configurations: state => {
        return state.configurations;
    },
    configurationsLoaded: state => {
        return state.configurationsLoaded;
    }
};
const mutations = {
    updateConfigurations: (state, configurations) => {
        state.configurations = configurations;
    },
    updateConfigurationsLoaded: (state, configurationsLoaded) => {
        state.configurationsLoaded = configurationsLoaded;
    }
};
const actions = {
    updateConfigurations: ({ commit }, configurations) => {
        commit("updateConfigurations", configurations);
    },
    updateConfigurationsLoaded: ({ commit }, configurationsLoaded) => {
        commit("updateConfigurationsLoaded", configurationsLoaded);
    },
};
export default{
    state,
    getters,
    mutations,
    actions
}